import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-precificador-decisao-certa',
  templateUrl: './consulta-precificador-decisao-certa.component.html',
  styleUrls: ['./consulta-precificador-decisao-certa.component.scss']
})
export class ConsultaPrecificadorDecisaoCertaComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
  }

}
